<template lang="pug">
	.briefs--list
		.tb-padding
			ListView.full-width(v-show="page === 'briefs'", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords", :getItems="(r) => r.Results", :getData="loadData", :columns="columns",
				:showColumnHeaders="true", :searchVisible="false", :autoFit="true", :bottomPagerVisible="false", :filterRow="false", :keyboardNavigationDisabled="true", :showPageSize="true")
				template(v-slot:item-template="{ data }")
					.flex-row.space-medium.align-center
						.brief-img(v-if="data.LogoUrl", :style="{ '--img': `url('${data.LogoUrl}')` }")
						span {{ data.Name }}
				template(v-slot:actions-template="{ data }")
					.flex-row.space.align-center.justify-end
						DxButton(v-if="!brandings.length" :text="$tCaption('Open brief in new tab')", @click="openBrief(data)")
						DxDropDownButton(v-else, :text="$tCaption('Open brief in new tab')" :items="actions", stylingMode="filled",  display-expr="name", key-expr="id", :use-select-mode="false", :showArrowIcon="false", 
							:drop-down-options="dropdownOptions", @item-click="e => onActionClick(e, data)")
				.flex-row.space.align-center.justify-end(slot="left-actions")
					.font-big.upper.accent-color {{$tCaption('Briefs')}}
					template(v-if="brandings.length")
						span |
						.upper.clickable.hoverable(@click="page = 'brandings'") {{$tCaption('Branding')}}
			ListView.full-width(v-if="page === 'brandings'", initialView="table", :hideViewsSelection="true", :getTotal="(r) => r.length", :getItems="(r) => r", :getData="() => brandings", :columns="brandingColumns",
				:showColumnHeaders="true", :searchVisible="false", :autoFit="true", :bottomPagerVisible="false", :filterRow="false", :keyboardNavigationDisabled="true", :showPageSize="true")
				template(v-slot:item-template="{ data }")
					.flex-row.space-medium.align-center
						.brief-img(v-if="data.LogoUrl", :style="{ '--img': `url('${data.LogoUrl}')` }")
						.flex-col.space.wrap
							.font-big.flex-row.space 
								span {{ data.Name }}
								span(v-if="data.CompanyName && data.Name !== data.CompanyName") ({{ data.CompanyName }})
							.about.wrap.flex-1(v-if="data.About") {{ data.About }}
							.font-small.grey(v-if="data.Copyright") {{ data.Copyright }}
				template(v-slot:actions-template="{ data }")
					.flex-row.space.align-center.justify-end
						DxButton(icon="fas fa-gears", :text="$tCaption('Configure')", @click="configureBranding(data)")
				.flex-row.space.align-center.justify-end(slot="left-actions")
					.upper.clickable.hoverable(@click="page = 'briefs'") {{$tCaption('Briefs')}}
					span |
					.font-big.upper.accent-color {{$tCaption('Branding')}}
		BrandingConfigurator(ref="brandingConfigurator")
</template>

<script>
import ListView from 'app-core/ListView.vue';
import DxButton from 'devextreme-vue/button';
import DxTextBox from 'devextreme-vue/text-box';
import DxTextArea from 'devextreme-vue/text-area';
import Popup from 'app-core/Popup.vue';
import Loader from 'app-core/Loader.vue';
import DxSelectBox from 'devextreme-vue/select-box';
import DxDropDownButton from 'devextreme-vue/drop-down-button';
import BrandingConfigurator from './BrandingConfigurator.vue';

export default {
	translationCategory: 'briefs.List',
	components: { ListView, DxButton, Popup, Loader, DxTextBox, DxTextArea, DxSelectBox, DxDropDownButton, BrandingConfigurator },
	props: [],
	data() {
		return {
			columns: [
				{ dataField: 'Name', caption: () => this.$tCaption('Name'), cellTemplate: 'item-template' },
				{ dataField: 'IsPublic', caption: () => this.$tCaption('Public') },
				{ dataField: 'Name', name: 'actions', caption: () => '', cellTemplate: 'actions-template' },
			],
			brandingColumns: [
				{ dataField: 'Name', caption: () => this.$tCaption('Name'), cellTemplate: 'item-template' },
				{ dataField: 'Name', name: 'actions', caption: () => '', cellTemplate: 'actions-template' },
			],
			isLoading: 0,
			page: 'briefs',
			brandings: [],
			dropdownOptions: { 
				width: 230
			}
		};
	},
	computed: {
		actions() {
			return [
				{ id: 'no-branding', name: this.$tCaption('No branding'), icon: 'far fa-circle-xmark' },
				...this.brandings.map(f => ({
					id: f.Oid,
					name: f.Name, 
					icon: 'fas fa-palette'
				}))
			]
		}
	},
	watch: {
		
	},
	mounted() {
		if (__DEBUG__)
			window.briefsList = this;
		
		this.loadBrandings();
	},
	destroyed() {
	},
	methods: {
		loadData(page, limit, opts) {
			return this.$Data.getExternalApi('Brief/GetAllBriefs', `page=${page + 1}`, limit)
		},
		openBrief(brief, branding) {
			const routeData = this.$router.resolve({ path: `easy-creative/${branding || 'pass'}?briefId=${brief?.Oid}` });
			window.open(routeData.href, '_blank');
		},
		async loadBrandings() {
			let filter = [];
			/*if (opts?.searchString) {
				filter = [["Name", "contains", opts?.searchString], "OR", ["Description", "contains", opts?.searchString]];
			}*/
			let filterCriteria = `${filter && filter.length && `&filterCriteria=${encodeURIComponent(JSON.stringify(filter))}` || ''}`;
			this.brandings = (await this.$Data.getExternalApi('BriefBranding/List', `page=1&filterCriteria=${filterCriteria}`, 999))?.Results;
		},
		onActionClick(e, brief) {
			if (e.itemData.id === 'no-branding') {
				this.openBrief(brief);
			} else {
				this.openBrief(brief, e.itemData.id);
			}
		},
		configureBranding(branding) {
			this.$refs.brandingConfigurator.show(branding);
		}
	}
};
</script>
<style lang="scss">
	@import "main/themes/generated/variables.base.scss";
	.briefs--list {
		.brief-img {
			width: 60px;
			height: 60px;
			min-width: 60px;
			background: var(--img);
			background-size: cover;
			border-radius: 4px;
		}
	}
</style>
